// document.addEventListener("product:variant-change", function (evt) {
//     const skuText = document.getElementById("sku_text");
//     if (skuText) {
//         skuText.textContent = evt.detail.variant.sku;
//     }
// });

// document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//   bubbles: true
// }));

// document.addEventListener("cart:item-added", function (evt) {
//     console.log("added to cart");
//     var cartToggle = document.getElementById("cart-drawer-toggle");
//     if (cartToggle) {
//         cartToggle.click();
//     }

// });
// function hideSingleOption() {
//   document.querySelectorAll(".bundly__product_option").forEach((option) => {
//     const radios = option.querySelectorAll(".bundly__variant_radio");

//     if (radios.length === 1) {
//       option.style.display = "none"; // Hide the option
//       option.remove();
//     }
//   });
// }

// // Global event listener to detect clicks on any radio button
// document.addEventListener("click", (event) => {
//   const target = event.target;

//   // Check if the clicked element is a radio button inside .bundly__fixed
//   if (target.matches(".bundly__fixed input.bundly__variant_radio")) {
//     // Delay the hiding function slightly to allow UI updates
//     // setTimeout(hideSingleOption, 100);
//   }
// });

// // Run hide function on initial load
// // hideSingleOption();

// document.addEventListener("DOMContentLoaded", function () {
//   const options = document.querySelectorAll(".bundly__product_option");

//   async function clickValidRadios() {
//     console.log("Auto Click Radio Values");
//     for (const option of options) {
//       const radioButtons = option.querySelectorAll(".bundly__variant_radio");

//       // Find the first non-disabled radio button
//       const validRadio = Array.from(radioButtons).find(
//         (radio) => !radio.classList.contains("bundly__variant_radio_disabled")
//       );

//       if (validRadio) {
//         validRadio.click();
//         await new Promise((resolve) => setTimeout(resolve, 500)); // Wait 500ms before next iteration
//       }
//     }
//   }

//   clickValidRadios();
// //   hideSingleOption();
// });

document.addEventListener("bundlySubmit", (event) => {
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
    })
  );

  var cartToggle = document.getElementById("cart-drawer-toggle");
  if (cartToggle) {
    cartToggle.click();
  }
});

// document.addEventListener("DOMContentLoaded", function () {


//     var bundlyMedias = document.querySelector(".bundly__medias");
//     if (!bundlyMedias) return;

//     var originalList = bundlyMedias.querySelector("ul");
//     if (!originalList) return;

//     // Clone the original list
//     var clonedList = originalList.cloneNode(true);
    
//     // Create the thumbnails div and append cloned list
//     var thumbnailsDiv = document.createElement("div");
//     thumbnailsDiv.classList.add("thumbnails");
//     thumbnailsDiv.appendChild(clonedList);

//     // Append thumbnails to bundly__medias
//     bundlyMedias.appendChild(thumbnailsDiv);

//     var flkty = new Flickity(".bundly__medias>ul", {
//         wrapAround: true,
//         pageDots: true,
//         prevNextButtons: true,
//         contain: true,
//         draggable: true,
//         cellAlign: "center",
//         adaptiveHeight: true,
//     });
//      // Initialize Flickity for thumbnails as navigation
//     var flktyNav = new Flickity(".thumbnails > ul", {
//         asNavFor: ".bundly__medias > ul",
//         contain: true,
//         pageDots: false,
//         prevNextButtons: false,
//         cellAlign: "center",
//         draggable: true,
//     });
// });


document.addEventListener("DOMContentLoaded", function () {
  const checkbox = document.getElementById("Filter-Mobile-availability-4");
  if (checkbox && checkbox.checked == false) {
    checkbox.click();
  }

});
